export default "__VITE_ASSET__e7e0c301__"